import type {
  AllowListDomain,
  AllowListFile,
  AllowListType,
  AllowListUser,
} from "shared-core/types/allow-list";

export const GoogleWorkspaceAllowListStoreInjectKey = Symbol(
  "googleWorkspaceAllowListStoreInjectKey",
);
export const MicrosoftAllowListStoreInjectKey = Symbol(
  "microsoftAllowListStoreInjectKey",
);

export interface AllowListStoreActions {
  fetchData(): Promise<void>;
  allow(type: AllowListType, value: string): Promise<void>;
  requestAllow(type: AllowListType, value: string): Promise<void>;
}

export interface AllowListSettingsStoreActions extends AllowListStoreActions {
  /** Resolves false when the decision was saved but the list could not be reloaded. */
  approve(type: AllowListType, value: string): Promise<boolean>;
  deny(type: AllowListType, value: string): Promise<boolean>;
}

export interface AllowListPendingStore extends Pick<
  AllowListSettingsStoreActions,
  "approve" | "deny"
> {
  pending: {
    users: AllowListUser[];
    domains: AllowListDomain[];
    files: AllowListFile[];
  };
}

export interface AllowListSettingsPanelStore extends AllowListPendingStore {
  approved: {
    users: (AllowListUser | Omit<AllowListUser, "createdAt">)[];
    domains: (AllowListDomain | Omit<AllowListDomain, "createdAt">)[];
    files: (AllowListFile | Omit<AllowListFile, "createdAt">)[];
  };
  fetchData(): Promise<void>;
  addTrustedUser(email: string): void;
  removeTrustedUser(email: string): void;
  addTrustedDomain(domain: string): void;
  removeTrustedDomain(domain: string): void;
  removeAllowedFile(id: string): void;
  saveSettings(): Promise<void>;
}
